import React from 'react'

// REDUX ACTIONS
import {Link} from "react-router-dom";

/*** REACT TOOLBOX ***/
import List from 'react-toolbox/lib/list/List'
import ListItem from 'react-toolbox/lib/list/ListItem'
import CheckBox from 'react-toolbox/lib/checkbox/Checkbox'
import Button from 'react-toolbox/lib/button/Button'
import IconButton from 'react-toolbox/lib/button/IconButton'
import ListSubHeader from 'react-toolbox/lib/list/ListSubHeader'
import ListDivider from 'react-toolbox/lib/list/ListDivider'

import './StationList.css'
// import {PulseLoader} from "halogen";


const handleStations = props => {
    if (props.stations)
        return props.stations.filter((entity, key) => key <= props.page * 20 || key >= props.page * 20)
            .map((entity, key) => {
                return (
                    <ListItem
                        key={key}
                        caption={entity.alias}
                        label={entity.alias}
                        className={entity.checked ? 'selected' : ''}
                        leftActions={[
                            <CheckBox
                                className={'nodeListCheckBox'}
                                key={key}
                                checked={entity.checked}
                                onChange={() => props.handleCheckBoxChange(key)}
                            />
                        ]}
                        rightActions={[
                            <Link to={`/stations/map/${entity.station}`} key={`${key}_2`}>
                                <IconButton
                                    key={key}
                                    icon="location_on"
                                    primary/>
                            </Link>,
                            <Link to={`/stations/chart/${entity.station}/alias/${entity.alias}`} key={`${key}_3`}>
                                <IconButton
                                    key={key}
                                    icon="insert_chart"
                                    primary/>
                            </Link>
                        ]}
                    />
                )
            });
    else
        return ""
};

export const StationList = props => {

    if (props.stations) {

        let checkList = "/";

        props.stations.forEach(entity => {
            if (entity.checked)
                checkList += entity.station + ',';
        });

        checkList = checkList.slice(0,-1) + '/alias/';

        props.stations.forEach(entity => {
            if (entity.checked)
                checkList += entity.alias + ',';
        });

        checkList = checkList.slice(0,-1);

        return (
            <div className=" col-xs-12 nodeContent">
                <div className="nodeListContainer">
                    <div className="listHeader">
                        <ListSubHeader className="listSubheader"
                                       caption={`${props.organization ? props.organization : '          '} stations`}/>
                        <div className={'iconHeader'}>
                            {checkList.length > 1 &&
                            <Link to={`/stations/map${checkList.split('alias').slice(0,-1)}`} key={`map`}>
                                <IconButton
                                    key={'map'}
                                    icon="location_on"
                                    primary/>
                            </Link>}
                            {checkList.length > 1 &&
                            <Link to={`/stations/chart${checkList}`} key={'explore'}>
                                <IconButton
                                    key={'explore'}
                                    icon="insert_chart"
                                    primary
                                    className="listHeaderButton"/>
                            </Link>}
                        </div>
                    </div>
                    <ListDivider/>
                    <List selectable ripple className={'nodeList'}>
                        {handleStations(props)}
                        {props.count > 19 && <ListDivider/>}
                        {props.count > 19 && <ListItem key={'Paginator'}
                                                       rightActions={[
                                                           <IconButton
                                                               key={'Paginator'}
                                                               icon='keyboard_arrow_left'
                                                               primary
                                                               onClick={() => props.handleSensorsPage("previous")}
                                                           />,
                                                           <IconButton
                                                               key={'Paginator'}
                                                               icon="keyboard_arrow_right"
                                                               primary
                                                               onClick={() => props.handleSensorsPage("next")}
                                                           />
                                                       ]}
                        />}
                    </List>
                </div>
                {checkList.length > 1 &&
                <div className={'bottomRigthFixedButton dataExplorerButton'}>
                    <Link to={`/stations/chart${checkList}`}>
                        <Button label={'Data Explorer'} primary raised/>
                    </Link>
                </div>}
            </div>
        );
    } else
        return (
            null
            /*<PulseLoader className="LoadTable"*/
            // color="#0A2A59"
            // size={"20px"}
            // margin={"4px"}/>
        );
};


// WEBPACK FOOTER //
// ./src/components/DashBoard/ManageStations/StationList/StationList.js